import React from 'react';

import { BodyLargeText, Column, H3 } from 'playful-ui';

export const Module3 = () => (
  <React.Fragment>
    <Column>
      <H3 style={{ textAlign: 'center', alignSelf: 'center', marginTop: '32px' }}>Modul 3</H3>
      <BodyLargeText><b>Dolazi uskoro...</b></BodyLargeText>
      <BodyLargeText>Osmisli i <b>programiraj animacije</b> na nizu višebojnih LED lampica</BodyLargeText>
      <BodyLargeText><b>Programiraj plesne korake</b> robota kroz Arduino programsko okruženje.</BodyLargeText>
    </Column>
  </React.Fragment>
);
